import AtlassianIntelligenceTeam24 from "./team24-modals/atlassian-intelligence";

export default AtlassianIntelligenceTeam24;
